export enum PlaylistMode {
  Off = 'Off',
  OnNormal = 'OnNormal',
  OnTeaser = 'OnTeaser'
}